import { atom } from 'jotai'

import { type DetailInfo } from '@/features/vehicle-dispatch-boards'

/**
 * ドラッグ中の配送依頼がホバーしている予定・空き時間枠（複数対応）
 */
export const dragOverScheduleItemAtom = atom<{
  dispatchDetails: DetailInfo[]
  isTimeRestrictionValid: boolean
} | null>(null)

dragOverScheduleItemAtom.debugLabel = 'dragOverScheduleItemAtom'
